export async function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    try {
      await navigator.serviceWorker.register('/sw.js');
    } catch (e) {
      console.log(`SW registration failed`, e);
    }
  }
}
